import { render, staticRenderFns } from "./ComponentDailyLoser.vue?vue&type=template&id=3a315688"
import script from "./ComponentDailyLoser.vue?vue&type=script&lang=js"
export * from "./ComponentDailyLoser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports